import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ActivatedRoute, Params } from '@angular/router';
import * as _ from 'lodash';
import { NgForage } from 'ngforage';
import { IAlbum, Lightbox } from 'ngx-lightbox';
import { partial } from 'ramda';
import { Subject } from 'rxjs';
import AddressHelper from 'src/app/helpers/address-helper';
import AssetHelper from 'src/app/helpers/asset-helper';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import ErrorHelper from 'src/app/helpers/error-helper';
import { GeneralHelper } from 'src/app/helpers/general-helper';
import SubmitQueueHelper from 'src/app/helpers/offline-submit/submit-queue-helper';
import ProductHelper from 'src/app/helpers/product-helper';
import ProjectHelper from 'src/app/helpers/project-helper';
import SemaphoreHelper from 'src/app/helpers/semaphore-helper';
import { StringHelper } from 'src/app/helpers/string-helper';
import Asset from 'src/app/model/asset';
import Company from 'src/app/model/company/company';
import ProductAsset from 'src/app/model/product-asset';
import Board from 'src/app/model/product/board/board';
import BoardPlacement from 'src/app/model/product/board/board-placement';
import OtherProduct from 'src/app/model/product/other-product/other-product';
import OtherProductPlacement from 'src/app/model/product/other-product/other-product-placement';
import Product from 'src/app/model/product/product';
import { ProductTypes } from 'src/app/model/product/product-type';
import Windowsticker from 'src/app/model/product/windowsticker/windowsticker';
import WindowStickerPlacement from 'src/app/model/product/windowsticker/windowsticker-placement';
import { Adjustment } from 'src/app/model/project/adjustment';
import { BaseProject } from 'src/app/model/project/base-project';
import { Project } from 'src/app/model/project/project';
import { SubProject } from 'src/app/model/project/sub-project';
import { REGISTERED_ACTION_TYPES } from 'src/app/model/registered-action-type';
import { TaskList } from 'src/app/model/task-list/task-list';
import { FormatPhoneNumber } from 'src/app/modules/app-pipes/format-phonenumber';
import { CompanyDisplayDialogComponent } from 'src/app/modules/company/company-display-dialog/company-display-dialog.component';
import { FormatDecimal } from 'src/app/pipes/format-decimal';
import {
  GroupProjectContactPipe,
  ProjectContactGroup,
} from 'src/app/pipes/group-project-contact';
import { AuthService } from 'src/app/services/auth.service';
import { ModalService } from 'src/app/services/modal.service';
import { OfflineProjectStorageService } from 'src/app/services/offline-project-storage.service';
import { OfflineStorageTimestampService } from 'src/app/services/offline-storage-timestamp.service';
import { OfflineAsset } from 'src/app/services/placer-offline-changes/offline-asset';
import { SubmitEventService } from 'src/app/services/placer-offline-changes/submit-event.service';
import { PlacerTasksService } from 'src/app/services/placer-tasks.service';
import { SnackService } from 'src/app/services/snack.service';
import { BoardLoadListComponent } from 'src/app/shared/project-components/helpers/load-list/board-load-list/board-load-list.component';
import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';
import {
  OfflineProductChangeObject,
  PlacerProductChangesService,
} from '../../../../services/placer-offline-changes/placer-product-changes.service';
import {
  PlacerSubmitService,
  SubmittedRegisteredActions,
} from '../../../../services/placer-offline-changes/placer-submit.service';
import {
  OfflineSubProjectChangeObject,
  PlacerSubProjectChangesService,
} from '../../../../services/placer-offline-changes/placer-subproject-changes.service';
import GeneralPlacerFormHelper from '../shared-helper/general-placer-form-helper';
import SubProductDisplay from '../shared-helper/sub-product-display';
import ProjectPlacerFormHelper from './helper/project-placer-form-helper';

@Component({
  selector: 'project-placer-form',
  templateUrl: './project-placer-form.component.html',
  styleUrls: [
    '../placer-form-shared-style.scss',
    './project-placer-form.component.scss',
  ],
  providers: [FormatPhoneNumber, FormatDecimal, GroupProjectContactPipe],
})
export class ProjectPlacerFormComponent
  extends SubscriptionBasedComponent
  implements OnInit, OnDestroy
{
  project: Project;
  baseProject: BaseProject;
  subProject: SubProject;
  companyNames: string[];

  init: boolean = false;
  bannerText: string;
  bannerClass: string;
  companyHeaderText: string;
  projectPlacementAddressEmpty: boolean = true;
  projectContactGroups: ProjectContactGroup[] = [];
  appointmentText: string;
  timeBudget: string;
  atLeastOneInpressLogo: boolean;
  heightEquipmentLine: string;
  placementFloor: string;
  extraPlacementInfo: string;
  extraInfoAddress: string;
  extraInfoSite: string;
  photos = [
    {
      src: '../../../../../assets/no-picture.jpg',
      caption: '',
      thumb: '../../../../../assets/no-picture.jpg',
    },
  ];
  adjustmentPhotos = [];
  sitePhotos = [];
  multipleProducts: boolean;
  productDisplays: ProductDisplay[] = [];
  showStoreQuestion: boolean = false;
  showExtraSupplier: boolean = false;
  showExtraMaterials: boolean = false;
  showExternalSupplierAdjustment: boolean = false;
  extraHoogwerkerAdjustment: string;
  parkingBanAdjustment: string;
  extraSupplierAdjustment: string;
  extraMaterialsAdjustment: string;
  adjustmentPlacementInfoTitle: string;
  adjustmentExecutedClass: string;
  adjustmentExecutedString: string;
  adjustmentExecutedIcon: string;
  placementStarted: boolean = false;
  disallowStartPlacement: boolean = false;
  totalExecutionTime: string = ' in 0m';
  displayTotalExecutionTime: boolean = false;
  allowExecuted: boolean = false;
  allowNotExecuted: boolean = false;
  submitting: boolean = false;
  storingOfflineChange: boolean = false;
  submitInProgress: boolean = false;
  submitQueued: boolean = false;

  productChangesMap: Map<number, OfflineProductChangeObject>;
  private offlineProductStoreTriggerSubjects: Map<
    number,
    Subject<OfflineProductChangeObject>
  >;
  offlineSubProjectChangesObject: OfflineSubProjectChangeObject;
  offlineSubProjectStoreTriggerSubject: Subject<OfflineSubProjectChangeObject>;
  private offlineAssetsSet: Set<string> = new Set<string>();

  private employeeId: number;
  private dateString: string;
  private taskId: number;

  productTypes = ProductTypes;

  private static STORE_OFFLINE_CHANGE_DELAY = 1000;

  private static changeVisibleDamage: (
    o: OfflineProductChangeObject,
    s: string
  ) => void = (o, s) => {
    o.extraInfoVisibleDamage = s;
  };

  private static changeInstallerFeedback: (
    o: OfflineProductChangeObject,
    s: string
  ) => void = (o, s) => {
    o.installerFeedback = s;
  };

  private static changePlacerFeedback: (
    o: OfflineSubProjectChangeObject,
    s: string
  ) => void = (o, s) => {
    o.placerFeedback = s;
  };

  constructor(
    private route: ActivatedRoute,
    private ngForage: NgForage,
    private placerSubmitService: PlacerSubmitService,
    private authService: AuthService,
    private snackService: SnackService,
    private modalService: ModalService,
    private offlineProjectStorageService: OfflineProjectStorageService,
    private offlineStorageTimestampService: OfflineStorageTimestampService,
    private placerProductChangesService: PlacerProductChangesService,
    private placerSubProjectChangesService: PlacerSubProjectChangesService,
    private submitEventService: SubmitEventService,
    private _lightbox: Lightbox,
    private dialog: MatDialog,
    public formatPhoneNumber: FormatPhoneNumber,
    public groupProjectContactPipe: GroupProjectContactPipe
  ) {
    super();
  }

  ngOnInit() {
    this.addSubscription(this.route.params, (params: Params) => {
      const projectId =
        params['projectId'] == null ? null : Number(params['projectId']);
      if (projectId == null) {
        this.snackService.showError('projectId ontbreekt');
        return;
      }
      const subProjectId =
        params['subProjectId'] == null ? null : Number(params['subProjectId']);
      if (subProjectId == null) {
        this.snackService.showError('subProjectId ontbreekt');
        return;
      }
      this.employeeId =
        params['employeeId'] == null ? null : Number(params['employeeId']);
      if (this.employeeId == null) {
        this.snackService.showError('employeeId ontbreekt');
        return;
      }
      this.dateString = params['date'] == null ? null : params['date'];
      if (StringHelper.isEmpty(this.dateString)) {
        this.snackService.showError('date ontbreekt');
        return;
      }
      this.taskId = params['taskId'] == null ? null : Number(params['taskId']);
      if (this.taskId == null) {
        this.snackService.showError('taskId ontbreekt');
        return;
      }
      this.initProject(projectId, subProjectId);
    });
    this.addSubscription(
      this.placerSubmitService.getRegisteredActionsSubmittedForSubProjectObservable(),
      (submittedRegisteredActions: SubmittedRegisteredActions) => {
        if (
          this.subProject != null &&
          submittedRegisteredActions.subProjectId === this.subProject.id
        ) {
          if (this.subProject.projectPlacement != null) {
            this.subProject.projectPlacement.registeredActions =
              submittedRegisteredActions.registeredActions;
          }
          if (
            this.offlineSubProjectChangesObject != null &&
            this.offlineSubProjectChangesObject.registeredActions != null
          ) {
            this.offlineSubProjectChangesObject.registeredActions.length = 0;
          }
        }
      }
    );
    this.addSubscription(
      this.submitEventService.getSubmitInProgressChangedSubscribable(),
      () => {
        this.calculateSubmitInProgress();
      }
    );
    this.addSubscription(
      this.placerSubmitService.getToSubmitChangedSubscribable(),
      () => {
        this.calculateSubmitQueued();
      }
    );
  }

  ngOnDestroy(): void {
    if (
      this.offlineProductStoreTriggerSubjects != null &&
      this.offlineProductStoreTriggerSubjects.size > 0
    ) {
      this.offlineProductStoreTriggerSubjects.forEach((s) => s.complete());
      this.offlineProductStoreTriggerSubjects.clear();
    }
    if (this.offlineSubProjectStoreTriggerSubject != null) {
      this.offlineSubProjectStoreTriggerSubject.complete();
      this.offlineSubProjectStoreTriggerSubject = null;
    }
  }

  initProject(projectId: number, subProjectId: number) {
    this.addSubscription(
      this.offlineProjectStorageService.getProject(projectId),
      (res: Project) => {
        this.project = res;
        this.baseProject = CollectionHelper.isPopulated(
          this.project.subProjects
        )
          ? this.project.subProjects.find((sp) => sp.type === 'BaseProject')
          : null;
        this.subProject = CollectionHelper.isPopulated(this.project.subProjects)
          ? this.project.subProjects.find((sp) => sp.id === subProjectId)
          : null;
        if (this.baseProject == null) {
          this.snackService.showError(`Basisproject niet gevonden`);
          return;
        }
        if (this.subProject == null) {
          this.snackService.showError(
            `Subproject met id ${subProjectId} niet gevonden`
          );
          return;
        }
        this.preprocessProject()
          .then(() => {
            this.checkSubmitConditions();
            this.calculateSubmitInProgress();
            this.calculateSubmitQueued();
            this.init = true;
          })
          .catch((err) => {
            throw err;
          });
      },
      (err) => {
        if (err instanceof Error) {
          this.snackService.showError(err.message);
        } else {
          this.snackService.showError(err);
        }
      }
    );
  }

  async preprocessProject(): Promise<void> {
    this.bannerText = ProjectHelper.getType(this.subProject, null, false);
    this.bannerText =
      this.bannerText === 'Plaatsing' ? 'Te plaatsen' : this.bannerText;
    this.bannerClass = ProjectHelper.getTypeStatusString(
      this.subProject,
      null,
      false
    );
    this.bannerClass =
      this.bannerClass === 'plaatsing' ? 'plaatsing-banner' : this.bannerClass;
    this.companyNames = ProjectHelper.getDtoInvolvedCompanies(this.project).map(
      (c) => c.regularName
    );
    this.companyHeaderText =
      this.companyNames != null && this.companyNames.length > 1
        ? 'Bedrijven'
        : 'Bedrijf';
    if (this.subProject.projectPlacement != null) {
      this.appointmentText = this.subProject.projectPlacement.appointment
        ? `AFSPRAAK${
            StringHelper.isEmpty(
              this.subProject.projectPlacement.needAppointmentInfo
            )
              ? ''
              : `: `
          }`
        : '';
      this.projectPlacementAddressEmpty = AddressHelper.isEmptyAddress(
        this.subProject.projectPlacement.address
      );
    }
    if (this.baseProject.projectPlacement != null) {
      this.placementFloor = this.baseProject.projectPlacement.placementFloor;
      this.extraPlacementInfo =
        this.baseProject.projectPlacement.extraPlacementInfo;
      this.extraInfoAddress =
        this.baseProject.projectPlacement.extraInfoAddress;
      this.extraInfoSite = this.baseProject.projectPlacement.extraInfoSite;
    }
    if (this.subProject.projectPlacement.registeredActions == null) {
      this.subProject.projectPlacement.registeredActions = [];
    }
    this.preprocessContacts();
    this.preprocessSitePhotos();
    await this.prepareOfflineSubProjectChangesObject();
    this.preprocessProjectExecutionActions();
    if (this.subProject.type !== 'BaseProject') {
      this.preprocessAdjustment();
    } else {
      await this.constructProductChangesMap();
      this.constructOfflineProductStoreTriggerSubjects();
      this.disallowStartPlacement =
        this.project.products != null &&
        this.project.products.every(
          (p) =>
            p.productPlacement != null &&
            p.productPlacement.executionComplete === true
        );
      this.displayTotalExecutionTime = this.disallowStartPlacement;
    }
    this.preprocessProducts();
  }

  private preprocessProducts() {
    if (CollectionHelper.isPopulated(this.project.products)) {
      this.multipleProducts = this.project.products.length > 1;
      let timeBudgetMinutes = 0;
      const heightEquipmentValues = new Set<string>();
      this.project.products.forEach((p, i) => {
        this.atLeastOneInpressLogo =
          this.atLeastOneInpressLogo || p.inpressLogo;
        if (p.productPlacement != null) {
          if (this.subProject.type === 'BaseProject') {
            timeBudgetMinutes +=
              (p.productPlacement.installerHourBudget == null
                ? 0
                : p.productPlacement.installerHourBudget * 60) +
              (p.productPlacement.installerMinuteBudget == null
                ? 0
                : p.productPlacement.installerMinuteBudget);
          }
          if (p.productPlacement.heightEquipment != null) {
            heightEquipmentValues.add(p.productPlacement.heightEquipment.name);
          }
        }
        if (CollectionHelper.isPopulated(p.productAssets)) {
          const assetAlbum = [];
          p.productAssets.forEach((a) => {
            if (a.archived || !ProductHelper.isDesignAsset(a)) {
              return;
            }
            assetAlbum.push({
              src: 'api/assets/' + a.asset.uuid,
              caption: a.formSection,
              thumb: 'api/assets/' + a.asset.uuid + '/30',
            });
          });
          this.photos = assetAlbum.length === 0 ? this.photos : assetAlbum;
        }
        this.productDisplays.push(this.getProductDisplay(p, i));
      });
      if (this.subProject.type === 'BaseProject') {
        const hours = Math.floor(timeBudgetMinutes / 60);
        const minutes = timeBudgetMinutes % 60;
        this.timeBudget = StringHelper.join(
          [
            hours === 0 ? null : `${hours} uur`,
            minutes === 0
              ? null
              : `${minutes} ${minutes === 1 ? 'minuut' : 'minuten'}`,
          ],
          ' '
        );
      }
      this.heightEquipmentLine =
        heightEquipmentValues.size > 0
          ? StringHelper.join([...heightEquipmentValues.values()], ', ')
          : null;
      if (
        this.subProject.type === 'BaseProject' &&
        CollectionHelper.isPopulated(this.productDisplays)
      ) {
        for (const productDisplay of this.productDisplays) {
          this.showExtraSupplier =
            this.showExtraSupplier || productDisplay.showExtraSupplier;
          this.showExtraMaterials =
            this.showExtraMaterials || productDisplay.showExtraMaterials;
          if (this.showExtraSupplier && this.showExtraMaterials) {
            break;
          }
        }
      }
    }
  }

  private getProductDisplay(product: Product, index: number): ProductDisplay {
    const forAdjustment = this.subProject.type !== 'BaseProject';
    const executed = this.getExecuted(product);
    const designAssets = !CollectionHelper.isPopulated(product.productAssets)
      ? null
      : product.productAssets
          .filter(
            (pa) =>
              !pa.archived &&
              ((!forAdjustment && ProductHelper.isDesignAsset(pa)) ||
                (forAdjustment && pa.formSection === 'execution'))
          )
          .map((pa) => {
            return {
              src: 'api/assets/' + pa.asset.uuid,
              caption: pa.formSection,
              thumb: 'api/assets/' + pa.asset.uuid + '/30',
              preview: 'api/assets/' + pa.asset.uuid + '/177/100',
            };
          });
    let extraHoogwerker = false;
    let extraHoogwerkerDescription = null;
    let parkingBan = false;
    let extraInfoParkingBan = null;
    let needExtraSupplier = false;
    let extraInfoNeedExtraSupplier = null;
    let needExtraMaterials = false;
    let extraInfoNeedExtraMaterials = null;
    if (product.productPlacement != null) {
      extraHoogwerker = product.productPlacement.extraHoogwerker;
      extraHoogwerkerDescription = product.productPlacement.extraHoogwerker
        ? StringHelper.isEmpty(
            product.productPlacement.extraHoogwerkerDescription
          )
          ? 'Ja'
          : product.productPlacement.extraHoogwerkerDescription
        : null;
      parkingBan = product.productPlacement.parkingBan;
      extraInfoParkingBan = product.productPlacement.parkingBan
        ? StringHelper.isEmpty(product.productPlacement.extraInfoParkingBan)
          ? 'Ja'
          : product.productPlacement.extraInfoParkingBan
        : null;
      needExtraSupplier = product.productPlacement.needExtraSupplier;
      extraInfoNeedExtraSupplier = product.productPlacement.needExtraSupplier
        ? StringHelper.isEmpty(
            product.productPlacement.extraInfoNeedExtraSupplier
          )
          ? 'Ja'
          : product.productPlacement.extraInfoNeedExtraSupplier
        : null;
      needExtraMaterials = product.productPlacement.needExtraMaterials;
      extraInfoNeedExtraMaterials = product.productPlacement.needExtraMaterials
        ? StringHelper.isEmpty(
            product.productPlacement.extraInfoNeedExtraMaterials
          )
          ? 'Ja'
          : product.productPlacement.extraInfoNeedExtraMaterials
        : null;
    }
    const showExtraSupplier =
      this.subProject.type === 'BaseProject' &&
      (extraHoogwerker || parkingBan || needExtraSupplier);
    const showExtraMaterials =
      this.subProject.type === 'BaseProject' && needExtraMaterials;

    return {
      id: product.id,
      productType: ProductHelper.getTypeOf(product),
      productTypeValue: product.type,
      materialLine: this.getMaterialLine(product),
      subProductDisplays:
        ProjectPlacerFormHelper.getSubProductDisplays(product),
      sketchUpAlbum: GeneralPlacerFormHelper.getSketchupAlbum(product),
      alignStickerLine: this.getAlignStickerLine(product),
      boardPlaceInstructionsLine: this.getBoardPlaceInstructionsLine(product),
      boardDistanceFrontPostLine: this.getBoardDistanceFrontPostLine(product),
      boardTilingLine: this.getBoardTilingLine(product),
      title: product.title,
      text: product.text,
      productPhoneNumbers: this.getProductPhoneNumbers(product),
      immoscoopLogo: product.immoscoopLogo,
      spottoLogo: product.spottoLogo,
      obstaclesLine: this.getObstaclesLine(product, forAdjustment, index),
      oldStickersLine: this.getOldStickersLine(product),
      dryWetInsideOutside: this.getDryWetInsideOutside(product),
      newWoodPosts: this.getNewWoodPosts(product),
      installerInfo: this.getInstallerInfo(product),
      executedClass: executed.class,
      executedString: executed.string,
      executedIcon: executed.icon,
      album: designAssets,
      showExtraSupplier: showExtraSupplier,
      extraHoogwerker: extraHoogwerker,
      extraHoogwerkerDescription: extraHoogwerkerDescription,
      parkingBan: parkingBan,
      extraInfoParkingBan: extraInfoParkingBan,
      needExtraSupplier: needExtraSupplier,
      extraInfoNeedExtraSupplier,
      showExtraMaterials: showExtraMaterials,
      needExtraMaterials: needExtraMaterials,
      extraInfoNeedExtraMaterials: extraInfoNeedExtraMaterials,
    };
  }

  private getMaterialLine(product: Product): string {
    switch (product.type) {
      case ProductTypes.WINDOWSTICKER.value:
      case ProductTypes.CUSTOMWINDOWSTICKER.value:
        const windowSticker = <Windowsticker>product;
        return StringHelper.join(
          [
            windowSticker.temporaryMaterial ? 'Tijdelijk' : 'Permanent',
            windowSticker.foil == null ? null : windowSticker.foil.name,
            windowSticker.laminate == null ? null : windowSticker.laminate.name,
          ],
          ' - '
        );
      case ProductTypes.BOARD.value:
        return null;
      case ProductTypes.OTHER_PRODUCT.value:
        const otherProduct = <OtherProduct>product;
        return otherProduct.otherProductMaterial;
      default:
        return null;
    }
  }

  private getAlignStickerLine(product: Product): string {
    switch (product.type) {
      case ProductTypes.WINDOWSTICKER.value:
      case ProductTypes.CUSTOMWINDOWSTICKER.value:
        return (<WindowStickerPlacement>(
          (<Windowsticker>product).productPlacement
        )).alignment;
      default:
        return null;
    }
  }

  private getBoardPlaceInstructionsLine(product: Product): string {
    switch (product.type) {
      case ProductTypes.BOARD.value:
        return (<Board>product).placeInstructions;
      default:
        return null;
    }
  }

  private getBoardDistanceFrontPostLine(product: Product): string {
    switch (product.type) {
      case ProductTypes.BOARD.value:
        const board = <Board>product;
        return board.distanceFrontPostToStreet;
      default:
        return null;
    }
  }

  private getBoardTilingLine(product: Product): string {
    switch (product.type) {
      case ProductTypes.BOARD.value:
        return (<Board>product).tilingFormats;
      default:
        return null;
    }
  }

  private getProductPhoneNumbers(product: Product): string[] {
    return CollectionHelper.isPopulated(product.productPhoneNumbers)
      ? product.productPhoneNumbers
          .filter(
            (ppn) =>
              !StringHelper.isEmpty(ppn.phoneNumbers) &&
              ppn.phoneNumbers !== 'Geen'
          )
          .map((ppn) => this.formatPhoneNumber.transform(ppn.phoneNumbers))
      : null;
  }

  private getObstaclesLine(
    product: Product,
    forAdjustment = false,
    index?: number
  ): string {
    switch (product.type) {
      case ProductTypes.WINDOWSTICKER.value:
      case ProductTypes.CUSTOMWINDOWSTICKER.value:
        const windowSticker = <Windowsticker>product;
        const windowStickerPlacement = <WindowStickerPlacement>(
          windowSticker.productPlacement
        );
        return windowStickerPlacement == null ||
          windowStickerPlacement.windowObstacle == null
          ? null
          : windowStickerPlacement.windowObstacle === false
          ? forAdjustment
            ? null
            : 'Er zijn geen obstakels'
          : StringHelper.isEmpty(windowStickerPlacement.extraInfoWindowObstacle)
          ? forAdjustment && this.multipleProducts
            ? `Er zijn obstakels voor ${ProductHelper.getTypeOf(product)} #${
                index + 1
              }`
            : 'Er zijn obstakels'
          : `${
              forAdjustment && this.multipleProducts
                ? `Obstakels ${ProductHelper.getTypeOf(product)} #${
                    index + 1
                  }: ${windowStickerPlacement.extraInfoWindowObstacle}`
                : `${
                    forAdjustment
                      ? 'Obstakels: ' +
                        windowStickerPlacement.extraInfoWindowObstacle
                      : windowStickerPlacement.extraInfoWindowObstacle
                  }`
            }`;
      case ProductTypes.BOARD.value:
        const board = <Board>product;
        const boardPlacement = <BoardPlacement>board.productPlacement;
        return boardPlacement == null || boardPlacement.obstaclesPresent == null
          ? null
          : boardPlacement.obstaclesPresent === false
          ? 'Er zijn geen obstakels'
          : StringHelper.isEmpty(boardPlacement.obstaclesInfo)
          ? forAdjustment && this.multipleProducts
            ? `Er zijn obstakels voor ${ProductHelper.getTypeOf(product)} #${
                index + 1
              }`
            : 'Er zijn obstakels'
          : `${
              forAdjustment && this.multipleProducts
                ? `Obstakels ${ProductHelper.getTypeOf(product)} #${
                    index + 1
                  }: ${boardPlacement.obstaclesInfo}`
                : `${
                    forAdjustment
                      ? 'Obstakels: ' + boardPlacement.obstaclesInfo
                      : boardPlacement.obstaclesInfo
                  }`
            }`;
      case ProductTypes.OTHER_PRODUCT.value:
        const otherProductPlacement = <OtherProductPlacement>(
          product.productPlacement
        );
        return otherProductPlacement == null ||
          otherProductPlacement.obstaclesPresent == null
          ? null
          : otherProductPlacement.obstaclesPresent === false
          ? 'Er zijn geen obstakels'
          : StringHelper.isEmpty(otherProductPlacement.obstaclesInfo)
          ? forAdjustment && this.multipleProducts
            ? `Er zijn obstakels voor ${ProductHelper.getTypeOf(product)} #${
                index + 1
              }`
            : 'Er zijn obstakels'
          : `${
              forAdjustment && this.multipleProducts
                ? `Obstakels ${ProductHelper.getTypeOf(product)} #${
                    index + 1
                  }: ${otherProductPlacement.obstaclesInfo}`
                : `${
                    forAdjustment
                      ? 'Obstakels: ' + otherProductPlacement.obstaclesInfo
                      : otherProductPlacement.obstaclesInfo
                  }`
            }`;
      default:
        return null;
    }
  }

  private getOldStickersLine(product: Product): string {
    switch (product.type) {
      case ProductTypes.WINDOWSTICKER.value:
      case ProductTypes.CUSTOMWINDOWSTICKER.value:
        const windowSticker = <Windowsticker>product;
        const windowStickerPlacement = <WindowStickerPlacement>(
          windowSticker.productPlacement
        );
        return windowStickerPlacement == null ||
          windowStickerPlacement.oldStickerPresent == null
          ? null
          : windowStickerPlacement.oldStickerPresent === false
          ? 'Er zijn geen oude stickers'
          : StringHelper.isEmpty(
              windowStickerPlacement.extraInfoOldStickerPresent
            )
          ? 'Er zijn oude stickers'
          : `${windowStickerPlacement.extraInfoOldStickerPresent}`;
      default:
        return null;
    }
  }

  private getDryWetInsideOutside(product: Product): string {
    switch (product.type) {
      case ProductTypes.WINDOWSTICKER.value:
      case ProductTypes.CUSTOMWINDOWSTICKER.value:
        const windowSticker = <Windowsticker>product;
        const windowStickerPlacement = <WindowStickerPlacement>(
          windowSticker.productPlacement
        );
        return windowStickerPlacement == null
          ? null
          : StringHelper.join(
              [
                windowStickerPlacement.wet ? 'Nat' : 'Droog',
                windowStickerPlacement.inside ? 'Binnenkant' : 'Buitenkant',
              ],
              ' / '
            );
      default:
        return null;
    }
  }

  private getNewWoodPosts(product: Product): string {
    switch (product.type) {
      case ProductTypes.BOARD.value:
        const boardPlacement = <BoardPlacement>product.productPlacement;
        return boardPlacement == null || boardPlacement.newWoodPosts == null
          ? null
          : boardPlacement.newWoodPosts
          ? 'Niew hout'
          : 'Recup hout';
      default:
        return null;
    }
  }

  private getInstallerInfo(product: Product): string {
    return product.productPlacement == null
      ? null
      : product.productPlacement.installerInfo;
  }

  private calculateAdjustmentExtraSuppliers(): void {
    const adjustment = <Adjustment>this.subProject;
    this.extraHoogwerkerAdjustment = adjustment.extraHoogwerker
      ? StringHelper.isEmpty(adjustment.extraHoogwerkerDescription)
        ? 'Ja'
        : adjustment.extraHoogwerkerDescription
      : null;
    this.parkingBanAdjustment = adjustment.parkingBan
      ? StringHelper.isEmpty(adjustment.extraInfoParkingBan)
        ? 'Ja'
        : adjustment.extraInfoParkingBan
      : null;
    this.extraSupplierAdjustment = adjustment.needExtraSupplier
      ? StringHelper.isEmpty(adjustment.extraInfoNeedExtraSupplier)
        ? 'Ja'
        : adjustment.extraInfoNeedExtraSupplier
      : null;
    this.extraMaterialsAdjustment = adjustment.needExtraMaterials
      ? StringHelper.isEmpty(adjustment.extraInfoNeedExtraMaterials)
        ? 'Ja'
        : adjustment.extraInfoNeedExtraMaterials
      : null;
    this.showExternalSupplierAdjustment =
      adjustment.extraHoogwerker ||
      adjustment.parkingBan ||
      adjustment.needExtraSupplier;
  }

  private prepareOfflineSubProjectChangesObject(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.addSubscription(
        this.placerSubProjectChangesService.getOfflineSubProjectChangeObject(
          this.subProject.id
        ),
        async (o: OfflineSubProjectChangeObject) => {
          try {
            if (o != null) {
              this.offlineSubProjectChangesObject = o;
              this.subProject.projectPlacement.placerFeedback = // overwrite existing feedback if offline change
                o.placerFeedback == null
                  ? this.subProject.projectPlacement.placerFeedback
                  : o.placerFeedback;
              o.placerFeedback = // overwrite offline feedback if none exists and online feedback does exist
                o.placerFeedback == null &&
                !StringHelper.isEmpty(
                  this.subProject.projectPlacement.placerFeedback
                )
                  ? this.subProject.projectPlacement.placerFeedback
                  : o.placerFeedback;
            } else {
              this.offlineSubProjectChangesObject = {
                id: this.subProject.id,
                projectId: this.project.id,
              };
              if (
                !StringHelper.isEmpty(
                  this.subProject.projectPlacement.placerFeedback
                )
              ) {
                this.offlineSubProjectChangesObject.placerFeedback =
                  this.subProject.projectPlacement.placerFeedback;
              }
            }
            if (
              CollectionHelper.isPopulated(
                this.offlineSubProjectChangesObject.offlineAssets
              )
            ) {
              if (
                this.subProject.projectPlacement.projectPlacementAssets == null
              ) {
                this.subProject.projectPlacement.projectPlacementAssets = [];
              }
              for (const offlineAsset of this.offlineSubProjectChangesObject
                .offlineAssets) {
                const offlineProductAsset = await this.instantiateOfflineAsset(
                  offlineAsset
                );
                this.subProject.projectPlacement.projectPlacementAssets.push(
                  offlineProductAsset
                );
              }
              this.filterDuplicateOfflineAssets(
                this.subProject.projectPlacement.projectPlacementAssets
              );
            }
            if (this.subProject.projectPlacement.registeredActions == null) {
              this.subProject.projectPlacement.registeredActions = [];
            }
            if (
              CollectionHelper.isPopulated(
                this.offlineSubProjectChangesObject.registeredActions
              )
            ) {
              this.subProject.projectPlacement.registeredActions.push(
                ...this.offlineSubProjectChangesObject.registeredActions
              );
              this.subProject.projectPlacement.registeredActions.sort(
                GeneralHelper.compareRegisteredActionsDesc
              );
            }
            if (
              this.subProject.projectPlacement.registeredActions.length > 0 &&
              this.subProject.projectPlacement.registeredActions[0].type
                .ordinal ===
                REGISTERED_ACTION_TYPES.START_PROJECT_EXECUTION.ordinal
            ) {
              this.placementStarted = true;
            }
            resolve();
          } catch (err) {
            reject(err);
          }
        }
      );
      this.offlineSubProjectStoreTriggerSubject =
        new Subject<OfflineSubProjectChangeObject>();
      this.addSubscription(
        this.offlineSubProjectStoreTriggerSubject,
        (o: OfflineSubProjectChangeObject) => {
          this.storingOfflineChange = true;
          this.placerSubProjectChangesService
            .storeOfflineSubProjectChangeObject(o)
            .catch((err) => console.error(err))
            .finally(() => (this.storingOfflineChange = false));
        },
        () => {},
        ProjectPlacerFormComponent.STORE_OFFLINE_CHANGE_DELAY
      );
    });
  }

  private constructProductChangesMap(): Promise<void> {
    if (this.project.products != null) {
      return new Promise((resolve, reject) => {
        this.productChangesMap = new Map<number, OfflineProductChangeObject>();
        this.addSubscription(
          this.placerProductChangesService.getOfflineProductChangeObjects(
            this.project.products.map((p) => p.id)
          ),
          async (objects: OfflineProductChangeObject[]) => {
            if (CollectionHelper.isPopulated(objects)) {
              for (const o of objects) {
                this.productChangesMap.set(o.id, o);
              }
            }
            try {
              for (const product of this.project.products) {
                let o = this.productChangesMap.get(product.id);
                if (o == null) {
                  o = {
                    id: product.id,
                  };
                  this.productChangesMap.set(product.id, o);
                  this.placerProductChangesService.storeOfflineProductChangeObject(
                    o
                  );
                }
                if (product.productPlacement != null) {
                  product.productPlacement.installerFeedback = // overwrite existing feedback if offline change
                    o.installerFeedback == null
                      ? product.productPlacement.installerFeedback
                      : o.installerFeedback;
                  o.installerFeedback = // overwrite offline feedback if none exists and online feedback does exist
                    o.installerFeedback == null &&
                    !StringHelper.isEmpty(
                      product.productPlacement.installerFeedback
                    )
                      ? product.productPlacement.installerFeedback
                      : o.installerFeedback;
                  product.productPlacement.executionComplete =
                    typeof o.executionComplete === 'undefined'
                      ? product.productPlacement.executionComplete
                      : o.executionComplete;
                  if (
                    ProductHelper.isWindowSticker(product) ||
                    ProductHelper.isCustomWindowSticker(product)
                  ) {
                    const windowStickerPlacement = <WindowStickerPlacement>(
                      product.productPlacement
                    );
                    windowStickerPlacement.extraInfoVisibleDamage = // overwrite existing feedback if offline change
                      o.extraInfoVisibleDamage == null
                        ? windowStickerPlacement.extraInfoVisibleDamage
                        : o.extraInfoVisibleDamage;
                    o.extraInfoVisibleDamage = // overwrite offline feedback if none exists and online feedback does exist
                      o.extraInfoVisibleDamage == null &&
                      !StringHelper.isEmpty(
                        windowStickerPlacement.extraInfoVisibleDamage
                      )
                        ? windowStickerPlacement.extraInfoVisibleDamage
                        : o.extraInfoVisibleDamage;
                  }
                }
                if (CollectionHelper.isPopulated(o.offlineAssets)) {
                  if (product.productAssets == null) {
                    product.productAssets = [];
                  }
                  for (const offlineAsset of o.offlineAssets) {
                    const offlineProductAsset =
                      await this.instantiateOfflineAsset(offlineAsset);
                    product.productAssets.push(offlineProductAsset);
                  }
                  this.filterDuplicateOfflineAssets(product.productAssets);
                }
              }
              resolve();
            } catch (err) {
              reject(err);
            }
          }
        );
      });
    } else {
      return Promise.resolve();
    }
  }

  private async instantiateOfflineAsset(
    offlineAsset: OfflineAsset
  ): Promise<ProductAsset> {
    const productAsset = new ProductAsset();
    const asset = new Asset();
    productAsset.asset = asset;
    productAsset.formSection = offlineAsset.formSection;
    asset.name = offlineAsset.name;
    asset.type = offlineAsset.type;
    asset.localFileUuid = offlineAsset.localFileUuid;
    asset.localFile = await this.ngForage.getItem<File>(
      AssetHelper.getStorageKeyFor(offlineAsset.localFileUuid)
    );
    this.offlineAssetsSet.add(asset.localFileUuid);
    return productAsset;
  }

  private filterDuplicateOfflineAssets(productAssets: ProductAsset[]) {
    if (!CollectionHelper.isPopulated(productAssets)) {
      return;
    }
    const copy = [...productAssets];
    CollectionHelper.filterInPlace(
      productAssets,
      (pa1, arrayCopy) =>
        pa1.asset != null &&
        !arrayCopy.some(
          (pa2) =>
            pa1 !== pa2 &&
            pa2.asset != null &&
            pa1.asset.uuid === pa2.asset.uuid &&
            pa2.asset.localFileUuid != null
        ),
      copy
    ); // prefer to show offline assets
  }

  private constructOfflineProductStoreTriggerSubjects(): void {
    if (this.project.products != null) {
      this.offlineProductStoreTriggerSubjects = new Map<
        number,
        Subject<OfflineProductChangeObject>
      >();
      this.project.products.forEach((p) => {
        const subject = new Subject<OfflineProductChangeObject>();
        this.offlineProductStoreTriggerSubjects.set(p.id, subject);
        this.addSubscription(
          subject,
          (o: OfflineProductChangeObject) => {
            this.storingOfflineChange = true;
            this.placerProductChangesService
              .storeOfflineProductChangeObject(o)
              .catch((err) => console.error(err))
              .finally(() => (this.storingOfflineChange = false));
          },
          () => {},
          ProjectPlacerFormComponent.STORE_OFFLINE_CHANGE_DELAY
        );
      });
    }
  }

  private preprocessContacts() {
    if (CollectionHelper.isPopulated(this.project.projectContacts)) {
      this.projectContactGroups = this.groupProjectContactPipe.transform(
        this.project.projectContacts
      );
    }
  }

  private getExecuted(product: Product) {
    if (product.productPlacement == null) {
      return { string: null, class: null, icon: null };
    }
    if (product.productPlacement.executionComplete == null) {
      return {
        string: null,
        class: 'plaatsing',
        icon: 'circle-pending',
      };
    } else if (product.productPlacement.executionComplete) {
      return { string: 'Uitgevoerd', class: 'plaatsing', icon: 'circle-check' };
    } else {
      return {
        string: 'Niet uitgevoerd',
        class: 'plaatsing',
        icon: 'circle-cross',
      };
    }
  }

  private preprocessAdjustment() {
    this.adjustmentPlacementInfoTitle =
      ProjectHelper.getType(this.subProject) + ' info';
    this.showStoreQuestion = ProjectHelper.showStoreQuestion(
      this.subProject,
      this.project
    );
    const adjustmentDesignAssets = [];
    if (this.subProject.projectPlacement != null) {
      this.subProject.projectPlacement.placementDone =
        typeof this.offlineSubProjectChangesObject.placementDone === 'undefined'
          ? this.subProject.projectPlacement.placementDone
          : this.offlineSubProjectChangesObject.placementDone;
      this.timeBudget = StringHelper.join(
        [
          this.subProject.projectPlacement.installerHourBudget == null ||
          this.subProject.projectPlacement.installerHourBudget === 0
            ? null
            : `${this.subProject.projectPlacement.installerHourBudget} uur`,
          this.subProject.projectPlacement.installerMinuteBudget == null ||
          this.subProject.projectPlacement.installerMinuteBudget === 0
            ? null
            : `${this.subProject.projectPlacement.installerMinuteBudget} ${
                this.subProject.projectPlacement.installerMinuteBudget === 1
                  ? 'minuut'
                  : 'minuten'
              }`,
        ],
        ' '
      );
      if (
        CollectionHelper.isPopulated(
          this.subProject.projectPlacement.projectPlacementAssets
        )
      ) {
        this.subProject.projectPlacement.projectPlacementAssets.forEach((a) => {
          if (a.archived || !ProjectHelper.isAdjustmentDesignAsset(a)) {
            return;
          }
          adjustmentDesignAssets.push({
            src: 'api/assets/' + a.asset.uuid,
            caption: a.formSection,
            thumb: 'api/assets/' + a.asset.uuid + '/30',
            preview: 'api/assets/' + a.asset.uuid + '/177/100',
          });
        });
        this.adjustmentPhotos =
          adjustmentDesignAssets.length === 0
            ? this.adjustmentPhotos
            : adjustmentDesignAssets;
      }
      this.calculateAdjustmentExtraSuppliers();
      this.extraPlacementInfo = StringHelper.isEmpty(
        this.subProject.withPlacementNotes
      )
        ? this.extraPlacementInfo
        : this.subProject.withPlacementNotes;
      this.preprocessAdjustmentExecution();
      this.disallowStartPlacement =
        this.subProject.projectPlacement.placementDone === true;
      this.displayTotalExecutionTime = this.disallowStartPlacement;
    }
  }

  private preprocessAdjustmentExecution() {
    if (this.subProject.projectPlacement.placementDone == null) {
      this.adjustmentExecutedClass = ProjectHelper.getTypeStatusString(
        this.subProject
      );
      this.adjustmentExecutedString = null;
      this.adjustmentExecutedIcon = 'circle-pending';
    } else if (this.subProject.projectPlacement.placementDone) {
      this.adjustmentExecutedClass = ProjectHelper.getTypeStatusString(
        this.subProject
      );
      this.adjustmentExecutedString = 'Uitgevoerd';
      this.adjustmentExecutedIcon = 'circle-check';
    } else {
      this.adjustmentExecutedClass = ProjectHelper.getTypeStatusString(
        this.subProject
      );
      this.adjustmentExecutedString = 'Niet uitgevoerd';
      this.adjustmentExecutedIcon = 'circle-cross';
    }
  }

  private preprocessSitePhotos(): void {
    const subProject =
      this.subProject.type === 'BaseProject'
        ? this.subProject
        : ProjectHelper.getLatestAdjustmentOrBaseProject(this.project);
    this.sitePhotos =
      subProject.projectPlacement == null ||
      !CollectionHelper.isPopulated(
        subProject.projectPlacement.projectPlacementAssets
      )
        ? null
        : subProject.projectPlacement.projectPlacementAssets
            .filter(
              (pa) =>
                !pa.archived &&
                (pa.formSection === 'sitePhotos' ||
                  pa.formSection === 'locationTopdown' ||
                  pa.formSection === 'adjustmentPlacementSuccess')
            )
            .map((pa) => {
              return {
                src: 'api/assets/' + pa.asset.uuid,
                caption: pa.formSection,
                thumb: 'api/assets/' + pa.asset.uuid + '/30',
                preview: 'api/assets/' + pa.asset.uuid + '/177/100',
              };
            });
  }

  private preprocessProjectExecutionActions(): void {
    if (
      this.subProject.projectPlacement == null ||
      !CollectionHelper.isPopulated(
        this.subProject.projectPlacement.registeredActions
      )
    ) {
      return;
    }
    this.totalExecutionTime = ` in ${GeneralHelper.getMinutesInHourAndMinutes(
      ProjectHelper.getTotalProjectExecutionMinutes(
        this.subProject.projectPlacement
      )
    )}`;
  }

  private async calculateSubmitInProgress() {
    const inProgress = await this.submitEventService.getSubmitInProgressAsync();
    this.submitInProgress = SubmitQueueHelper.evaluateSubProjectInProgress(
      this.subProject.id,
      inProgress
    );
  }

  private async calculateSubmitQueued() {
    const queued = await this.placerSubmitService.getToSubmit();
    this.submitQueued = SubmitQueueHelper.evaluateSubProjectQueued(
      this.subProject.id,
      queued
    );
  }

  openLightbox() {
    this._lightbox.open(this.photos);
  }

  openSitePhotosLightbox(index: number) {
    this._lightbox.open(this.sitePhotos, index);
  }

  openAlbumLightbox(album: IAlbum[], index: number) {
    this._lightbox.open(album, index);
  }

  visibleDamageChange(value: string, index: number) {
    const product = this.project.products[index];
    (<WindowStickerPlacement>product.productPlacement).extraInfoVisibleDamage =
      value;
    this.storeOfflineProductChange(
      product,
      value,
      ProjectPlacerFormComponent.changeVisibleDamage
    );
  }

  installerFeedbackChange(value: string, index: number) {
    const product = this.project.products[index];
    product.productPlacement.installerFeedback = value;
    this.storeOfflineProductChange(
      product,
      value,
      ProjectPlacerFormComponent.changeInstallerFeedback
    );
    this.checkSubmitConditions();
  }

  placerFeedbackChange(value: string) {
    this.subProject.projectPlacement.placerFeedback = value;
    this.storeOfflineSubProjectChange(
      value,
      ProjectPlacerFormComponent.changePlacerFeedback
    );
    this.checkSubmitConditions();
  }

  storeOfflineProductChange(
    product: Product,
    arg: any,
    changeFunction: (o: OfflineProductChangeObject, a: any) => void
  ): void {
    let offlineProduct = this.productChangesMap.get(product.id);
    if (offlineProduct == null) {
      offlineProduct = { id: product.id };
      this.productChangesMap.set(offlineProduct.id, offlineProduct);
    }
    changeFunction(offlineProduct, arg);
    const subject = this.offlineProductStoreTriggerSubjects.get(product.id);
    if (subject != null) {
      subject.next(offlineProduct);
    }
  }

  productAssetStored(index: number) {
    const product = this.project.products[index];
    this.storeOfflineProductChange(
      product,
      product.productAssets,
      this.productAssetAdded
    );
    this.checkSubmitConditions();
  }

  projectAssetStored() {
    this.storeOfflineSubProjectChange(
      this.subProject.projectPlacement.projectPlacementAssets,
      this.projectPlacementAssetAdded
    );
    this.checkSubmitConditions();
  }

  private productAssetAdded: (
    o: OfflineProductChangeObject,
    productAssets: ProductAsset[]
  ) => void = (o, productAssets) => {
    this.generalAssetAddedFunction(o, productAssets);
  };

  private projectPlacementAssetAdded: (
    o: OfflineSubProjectChangeObject,
    productAssets: ProductAsset[]
  ) => void = (o, productAssets) => {
    this.generalAssetAddedFunction(o, productAssets);
  };

  private generalAssetAddedFunction: (
    o: { offlineAssets?: OfflineAsset[] },
    productAssets: ProductAsset[]
  ) => void = (o, productAssets) => {
    if (CollectionHelper.isPopulated(productAssets)) {
      productAssets.forEach((pa) => {
        if (
          pa.asset.localFileUuid != null &&
          !this.offlineAssetsSet.has(pa.asset.localFileUuid)
        ) {
          if (o.offlineAssets == null) {
            o.offlineAssets = [];
          }
          o.offlineAssets.push({
            name: pa.asset.name,
            type: pa.asset.type,
            formSection: pa.formSection,
            localFileUuid: pa.asset.localFileUuid,
          });
          this.offlineAssetsSet.add(pa.asset.localFileUuid);
        }
      });
    }
  };

  productAssetDeleted(index: number) {
    const product = this.project.products[index];
    this.storeOfflineProductChange(
      product,
      product.productAssets,
      this.productAssetDeletedFunction
    );
    this.checkSubmitConditions();
  }

  projectAssetDeleted() {
    this.storeOfflineSubProjectChange(
      this.subProject.projectPlacement.projectPlacementAssets,
      this.adjustmentAssetDeletedFunction
    );
    this.checkSubmitConditions();
  }

  private generalAssetDeletedFunction: (
    formSection: string,
    o: { offlineAssets?: OfflineAsset[] },
    productAssets: ProductAsset[]
  ) => void = (formSection, o, productAssets) => {
    const toDeleteLocalFiles = !CollectionHelper.isPopulated(productAssets)
      ? o.offlineAssets == null
        ? []
        : o.offlineAssets.map((a) => a.localFileUuid)
      : o.offlineAssets == null
      ? []
      : this.calculateDiff(o.offlineAssets, productAssets, formSection);
    if (toDeleteLocalFiles.length > 0) {
      toDeleteLocalFiles.forEach((uuid) => {
        this.offlineAssetsSet.delete(uuid);
      });
      CollectionHelper.filterInPlace(
        o.offlineAssets,
        (a) => !toDeleteLocalFiles.includes(a.localFileUuid)
      );
    }
  };

  private productAssetDeletedFunction = partial(
    this.generalAssetDeletedFunction,
    ['execution']
  );

  private adjustmentAssetDeletedFunction = partial(
    this.generalAssetDeletedFunction,
    ['adjustmentPlacementSuccess']
  );

  private calculateDiff(
    offlineAssets: OfflineAsset[],
    productAssets: ProductAsset[],
    formSection: string
  ): string[] {
    return _.difference(
      offlineAssets.map((o) => o.localFileUuid),
      productAssets
        .filter(
          (pa) =>
            pa != null &&
            pa.asset != null &&
            pa.formSection === formSection &&
            pa.asset.localFileUuid != null
        )
        .map((pa) => pa.asset.localFileUuid)
    );
  }

  storeOfflineSubProjectChange(
    arg: any,
    changeFunction: (o: OfflineSubProjectChangeObject, a: any) => void
  ): void {
    changeFunction(this.offlineSubProjectChangesObject, arg);
    this.offlineSubProjectStoreTriggerSubject.next(
      this.offlineSubProjectChangesObject
    );
  }

  checkSubmitConditions() {
    if (this.subProject.type === 'BaseProject') {
      this.checkBaseProjectSubmitConditions();
    } else {
      this.checkAdjustmentSubmitConditions();
    }
  }

  checkBaseProjectSubmitConditions() {
    let allowNotExecuted = true;
    let allowExecuted = true;
    for (const product of this.project.products) {
      if (
        !CollectionHelper.isPopulated(product.productAssets) ||
        !product.productAssets.some(
          (pa) => pa.formSection === 'execution' && !pa.archived
        )
      ) {
        allowExecuted = false;
      }
      if (
        product.productPlacement == null ||
        StringHelper.isEmpty(product.productPlacement.installerFeedback)
      ) {
        allowNotExecuted = false;
      }
      if (!allowNotExecuted && !allowExecuted) {
        break;
      }
    }
    this.allowNotExecuted = allowNotExecuted;
    this.allowExecuted = allowExecuted;
  }

  checkAdjustmentSubmitConditions() {
    this.allowNotExecuted =
      this.subProject.projectPlacement != null &&
      !StringHelper.isEmpty(this.subProject.projectPlacement.placerFeedback);
    this.allowExecuted =
      this.subProject.type === 'Repo' ||
      (this.subProject.projectPlacement != null &&
        CollectionHelper.isPopulated(
          this.subProject.projectPlacement.projectPlacementAssets
        ) &&
        this.subProject.projectPlacement.projectPlacementAssets.some(
          (pa) =>
            pa.formSection === 'adjustmentPlacementSuccess' && !pa.archived
        ));
  }

  async startPlacement() {
    if (this.offlineSubProjectChangesObject.registeredActions == null) {
      this.offlineSubProjectChangesObject.registeredActions = [];
    }
    const startAction = GeneralHelper.initializeRegisteredAction(
      this.authService.getAuthenticatedUser(),
      new Date(),
      REGISTERED_ACTION_TYPES.START_PROJECT_EXECUTION,
      true
    );
    this.offlineSubProjectChangesObject.registeredActions.unshift(startAction);
    if (
      this.subProject.projectPlacement != null &&
      this.subProject.projectPlacement.registeredActions != null
    ) {
      this.subProject.projectPlacement.registeredActions.unshift(startAction);
    }
    this.placementStarted = true;

    try {
      this.storingOfflineChange = true;
      await this.placerSubProjectChangesService.storeOfflineSubProjectChangeObject(
        this.offlineSubProjectChangesObject
      );
    } catch (err) {
      console.error(err);
    } finally {
      this.storingOfflineChange = false;
    }

    try {
      this.submitting = true;
      const registeredActions =
        await this.placerSubmitService.submitRegisteredActions(
          this.offlineSubProjectChangesObject
        );
      if (this.subProject.projectPlacement != null) {
        this.subProject.projectPlacement.registeredActions = registeredActions;
      }
    } catch (err) {
      console.error(err);
    } finally {
      this.submitting = false;
    }
  }

  async addStopAction(returnIfLatestIsStop = false): Promise<void> {
    if (this.offlineSubProjectChangesObject.registeredActions == null) {
      this.offlineSubProjectChangesObject.registeredActions = [];
    }
    if (
      (returnIfLatestIsStop &&
        this.offlineSubProjectChangesObject.registeredActions.length > 0 &&
        this.offlineSubProjectChangesObject.registeredActions[0].type
          .ordinal ===
          REGISTERED_ACTION_TYPES.STOP_PROJECT_EXECUTION.ordinal) ||
      (this.subProject.projectPlacement != null &&
        CollectionHelper.isPopulated(
          this.subProject.projectPlacement.registeredActions
        ) &&
        this.subProject.projectPlacement.registeredActions[0].type.ordinal ===
          REGISTERED_ACTION_TYPES.STOP_PROJECT_EXECUTION.ordinal)
    ) {
      return;
    }
    const stopAction = GeneralHelper.initializeRegisteredAction(
      this.authService.getAuthenticatedUser(),
      new Date(),
      REGISTERED_ACTION_TYPES.STOP_PROJECT_EXECUTION,
      true
    );
    this.offlineSubProjectChangesObject.registeredActions.unshift(stopAction);
    if (
      this.subProject.projectPlacement != null &&
      this.subProject.projectPlacement.registeredActions != null
    ) {
      this.subProject.projectPlacement.registeredActions.unshift(stopAction);
    }
    await this.placerSubProjectChangesService.storeOfflineSubProjectChangeObject(
      this.offlineSubProjectChangesObject
    );
  }

  async submitNotExecuted(): Promise<void> {
    this.submitting = true;
    if (this.subProject.type === 'BaseProject') {
      await this.doBaseProjectNotExecuted();
    } else {
      await this.doAdjustmentNotExecuted();
    }
    await this.addStopAction(true);
    this.placerSubmitService
      .submitProject(this.offlineSubProjectChangesObject)
      .then((res) => {
        this.processResponse(res);
        if (this.subProject.type === 'BaseProject') {
          this.processBaseProjectNotExecuted();
          this.doUpdateLocalBaseProject(res);
          this.cleanupOfflineProductChangeObjects();
        } else {
          this.processAdjustmentNotExecuted();
          this.doUpdateLocalAdjustment(res);
        }
        this.cleanupOfflineSubProjectChangeObject();
        this.submitting = false;
        this.placementStarted = false;
        this.displayTotalExecutionTime = false;
        this.snackService.showSuccess('Project succesvol opgeslagen');
      })
      .catch((err) => {
        console.error(err);
        if (ErrorHelper.isConnectionLostError(err)) {
          this.reflectOfflineChanges();
          this.displayTotalExecutionTime = false;
        }
      })
      .finally(() => (this.submitting = false));
  }

  async doBaseProjectNotExecuted(): Promise<void> {
    if (CollectionHelper.isPopulated(this.project.products)) {
      this.project.products.forEach((p) => {
        let offlineProductChanges = this.productChangesMap.get(p.id);
        if (offlineProductChanges == null) {
          offlineProductChanges = { id: p.id };
          this.productChangesMap.set(p.id, offlineProductChanges);
        }
        offlineProductChanges.executionComplete = false;
        offlineProductChanges.executionDate = null;
        offlineProductChanges.executionTime = null;
        if (p.productPlacement != null) {
          p.productPlacement.executionComplete = false;
          p.productPlacement.executionDate = null;
          p.productPlacement.executionTime = null;
          p.productPlacement.placedRegistration = null;
        }
      });
      await this.placerProductChangesService.storeOfflineProductChangeObjects([
        ...this.productChangesMap.values(),
      ]);
    }
  }

  async doAdjustmentNotExecuted(): Promise<void> {
    if (this.offlineSubProjectChangesObject != null) {
      this.offlineSubProjectChangesObject.placementDone = false;
      this.offlineSubProjectChangesObject.currentExecutionDate = null;
      await this.placerSubProjectChangesService.storeOfflineSubProjectChangeObject(
        this.offlineSubProjectChangesObject
      );
    }
    if (this.subProject.projectPlacement != null) {
      this.subProject.projectPlacement.placementDone = false;
      this.subProject.projectPlacement.placementDoneRegistration = null;
    }
  }

  processBaseProjectNotExecuted() {
    this.productDisplays.forEach((p) => {
      p.executedString = 'Niet uitgevoerd';
      p.executedIcon = 'circle-cross';
    });
  }

  processAdjustmentNotExecuted() {
    this.adjustmentExecutedIcon = 'circle-cross';
    this.adjustmentExecutedString = 'Niet uitgevoerd';
  }

  openCompanyDisplayDialog(company: Company) {
    const config = {
      company: company,
    };
    this.dialog.open(CompanyDisplayDialogComponent, {
      data: config,
    });
  }

  openConstructionMaterialsModal(productIndex: number): void {
    const product = this.project.products[productIndex];
    if (product != null && product.type === ProductTypes.BOARD.value) {
      this.modalService.openComponentInModal(
        BoardLoadListComponent,
        [
          { key: 'board', value: product },
          { key: 'disabled', value: true },
        ],
        null,
        { minWidth: '750px' }
      );
    }
  }

  async submitExecuted(): Promise<void> {
    this.submitting = true;
    if (this.subProject.type === 'BaseProject') {
      await this.doBaseProjectExecuted();
    } else {
      await this.doAdjustmentExecuted();
    }
    await this.addStopAction(true);
    this.placerSubmitService
      .submitProject(this.offlineSubProjectChangesObject)
      .then((res) => {
        this.processResponse(res);
        this.preprocessProjectExecutionActions();
        if (this.subProject.type === 'BaseProject') {
          this.processBaseProjectExecuted();
          this.doUpdateLocalBaseProject(res);
          this.cleanupOfflineProductChangeObjects();
        } else {
          this.processAdjustmentExecuted();
          this.doUpdateLocalAdjustment(res);
        }
        this.cleanupOfflineSubProjectChangeObject();
        this.submitting = false;
        this.placementStarted = false;
        this.disallowStartPlacement = true;
        this.displayTotalExecutionTime = true;
        this.snackService.showSuccess('Project succesvol opgeslagen');
      })
      .catch((err) => {
        console.error(err);
        if (ErrorHelper.isConnectionLostError(err)) {
          this.reflectOfflineChanges();
          this.displayTotalExecutionTime = true;
        }
      })
      .finally(() => (this.submitting = false));
  }

  async retrySubmit(): Promise<void> {
    this.submitting = true;
    try {
      await this.placerSubmitService.retrySubmit(this.subProject.id);
    } catch (err) {
      this.snackService.showError(err);
    } finally {
      this.submitting = false;
    }
  }

  processResponse(project: Project) {
    const onlineSubproject = project.subProjects.find(
      (sp) => sp.id === this.subProject.id
    );
    if (
      onlineSubproject != null &&
      this.subProject.projectPlacement != null &&
      onlineSubproject.projectPlacement != null &&
      CollectionHelper.isPopulated(
        onlineSubproject.projectPlacement.registeredActions
      )
    ) {
      this.subProject.projectPlacement.registeredActions =
        onlineSubproject.projectPlacement.registeredActions;
    }
  }

  async doBaseProjectExecuted(): Promise<void> {
    if (this.productChangesMap != null && this.productChangesMap.size > 0) {
      this.productChangesMap.forEach(() => {});
    }
    if (CollectionHelper.isPopulated(this.project.products)) {
      const date = new Date();
      const hours =
        date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
      const minutes =
        date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
      this.project.products.forEach((p) => {
        let offlineProductChanges = this.productChangesMap.get(p.id);
        if (offlineProductChanges == null) {
          offlineProductChanges = { id: p.id };
          this.productChangesMap.set(p.id, offlineProductChanges);
        }
        offlineProductChanges.executionComplete = true;
        offlineProductChanges.executionDate = date;
        offlineProductChanges.executionTime = hours + ':' + minutes;
        if (p.productPlacement != null) {
          p.productPlacement.executionComplete = true;
          p.productPlacement.executionDate = date;
          p.productPlacement.executionTime = hours + ':' + minutes;
        }
      });
      await this.placerProductChangesService.storeOfflineProductChangeObjects([
        ...this.productChangesMap.values(),
      ]);
    }
  }

  async doAdjustmentExecuted(): Promise<void> {
    const executionDate = new Date();
    if (this.offlineSubProjectChangesObject != null) {
      this.offlineSubProjectChangesObject.placementDone = true;
      this.offlineSubProjectChangesObject.currentExecutionDate = executionDate;
      await this.placerSubProjectChangesService.storeOfflineSubProjectChangeObject(
        this.offlineSubProjectChangesObject
      );
    }
    if (this.subProject.projectPlacement != null) {
      this.subProject.projectPlacement.placementDone = true;
      this.subProject.currentExecutionDate = executionDate;
    }
  }

  processBaseProjectExecuted() {
    this.productDisplays.forEach((p) => {
      p.executedString = 'Uitgevoerd';
      p.executedIcon = 'circle-check';
    });
  }

  processAdjustmentExecuted() {
    this.adjustmentExecutedIcon = 'circle-check';
    this.adjustmentExecutedString = 'Uitgevoerd';
  }

  cleanupOfflineProductChangeObjects(): void {
    if (this.productChangesMap.size > 0) {
      this.productChangesMap.clear();
    }
  }

  cleanupOfflineSubProjectChangeObject(): void {
    this.offlineSubProjectChangesObject = {
      id: this.subProject.id,
      projectId: this.project.id,
    };
  }

  async doUpdateLocalBaseProject(res: Project) {
    await this.updateLocalStorage(res);
  }

  async doUpdateLocalAdjustment(res: Project) {
    await this.updateLocalStorage(res);
  }

  async updateLocalStorage(res: Project) {
    if (res == null || !CollectionHelper.isPopulated(res.subProjects)) {
      return;
    }
    const subProject = res.subProjects.find(
      (sp) => sp.id === this.subProject.id
    );
    if (subProject == null) {
      return;
    }
    const now = Date.now();

    try {
      await Promise.all([
        this.updateOfflineTask(subProject, res, now),
        this.updateOfflineProject(res, now),
      ]);
    } catch (err) {
      console.error(err);
    }
  }

  private async updateOfflineTask(
    subProject: SubProject,
    project: Project,
    timestamp: number
  ): Promise<void> {
    return SemaphoreHelper.use(
      PlacerTasksService.offlineStorageMutex,
      async () => {
        const key = PlacerTasksService.getStorageKeyFor(
          this.employeeId,
          this.dateString
        );
        const taskList = localStorage.getItem(key);
        if (taskList == null) {
          return;
        }
        const parsedList = <TaskList>JSON.parse(taskList);
        if (
          parsedList == null ||
          !CollectionHelper.isPopulated(parsedList.tasks)
        ) {
          return;
        }
        const task = parsedList.tasks.find((t) => t.id === this.taskId);
        if (task == null) {
          return;
        }
        task.subProject.status = subProject.status;
        task.subProject.displayStatus = subProject.displayStatus;
        if (
          task.subProject.projectPlacement != null &&
          subProject.projectPlacement != null
        ) {
          task.subProject.projectPlacement.projectPlacementAssets =
            subProject.projectPlacement.projectPlacementAssets;
        }
        if (
          task.subProject.project != null &&
          CollectionHelper.isPopulated(task.subProject.project.products) &&
          CollectionHelper.isPopulated(project.products)
        ) {
          task.subProject.project.products.forEach((p, i) => {
            const onlineProduct = project.products[i];
            if (
              p.productPlacement != null &&
              onlineProduct.productPlacement != null
            ) {
              p.productPlacement.executionComplete =
                onlineProduct.productPlacement.executionComplete;
              p.productPlacement.executionDate =
                onlineProduct.productPlacement.executionDate;
              p.productPlacement.executionTime =
                onlineProduct.productPlacement.executionTime;
            }
          });
        }
        if (
          task.subProject.projectPlacement != null &&
          subProject.projectPlacement != null
        ) {
          task.subProject.projectPlacement.placementDone =
            subProject.projectPlacement.placementDone;
        }
        localStorage.setItem(key, JSON.stringify(parsedList));
        this.offlineStorageTimestampService.setTimestamps(
          PlacerTasksService.timestampCollectionKey,
          [
            {
              key: `${this.employeeId}-${this.dateString}`,
              timestamp: timestamp,
            },
          ]
        );
      }
    );
  }

  private async updateOfflineProject(
    project: Project,
    timestamp: number
  ): Promise<void> {
    return SemaphoreHelper.use(
      OfflineProjectStorageService.offlineStorageMutex,
      async () => {
        localStorage.setItem(
          OfflineProjectStorageService.getProjectStorageKey(project.id),
          JSON.stringify(project)
        );
        this.offlineStorageTimestampService.setTimestamps(
          OfflineProjectStorageService.timestampCollectionKey,
          [{ key: project.id.toString(), timestamp: timestamp }]
        );
      }
    );
  }

  private reflectOfflineChanges() {
    if (this.subProject.type === 'BaseProject') {
      this.reflectBaseProjectChanges();
    } else {
      this.reflectAdjustmentChanges();
    }
    if (this.subProject.projectPlacement.registeredActions == null) {
      this.subProject.projectPlacement.registeredActions = [];
    }
    if (
      CollectionHelper.isPopulated(
        this.offlineSubProjectChangesObject.registeredActions
      )
    ) {
      CollectionHelper.filterInPlace(
        this.subProject.projectPlacement.registeredActions,
        (r) => r.id != null
      );
      this.subProject.projectPlacement.registeredActions.push(
        ...this.offlineSubProjectChangesObject.registeredActions
      );
      this.subProject.projectPlacement.registeredActions.sort(
        GeneralHelper.compareRegisteredActionsDesc
      );
      this.preprocessProjectExecutionActions();
    }
  }

  private reflectBaseProjectChanges() {
    if (this.productChangesMap == null || this.productChangesMap.size === 0) {
      return;
    }
    if (CollectionHelper.isPopulated(this.project.products)) {
      for (let i = 0; i < this.project.products.length; i++) {
        const p = this.project.products[i];
        const productDisplay = this.productDisplays[i];
        if (p.productPlacement == null) {
          return;
        }
        const changes = this.productChangesMap.get(p.id);
        if (changes == null) {
          return;
        }
        p.productPlacement.installerFeedback = changes.installerFeedback;
        p.productPlacement.executionComplete = changes.executionComplete;
        const executed = this.getExecuted(p);
        productDisplay.executedClass = executed.class;
        productDisplay.executedString = executed.string;
        productDisplay.executedIcon = executed.icon;
      }
    }
  }

  private reflectAdjustmentChanges() {
    if (
      this.offlineSubProjectChangesObject == null ||
      this.subProject.projectPlacement == null
    ) {
      return;
    }
    this.subProject.projectPlacement.placementDone =
      this.offlineSubProjectChangesObject.placementDone;
    this.preprocessAdjustmentExecution();
  }

  trackById(index: number, obj: any): number {
    return GeneralHelper.trackById(index, obj);
  }
}

interface ProductDisplay {
  id: number;
  productType: string;
  productTypeValue: string;
  materialLine: string;
  subProductDisplays: SubProductDisplay[];
  sketchUpAlbum: IAlbum[];
  alignStickerLine: string;
  boardPlaceInstructionsLine: string;
  boardDistanceFrontPostLine: string;
  boardTilingLine: string;
  title: string;
  text: string;
  productPhoneNumbers: string[];
  immoscoopLogo: boolean;
  spottoLogo: boolean;
  obstaclesLine: string;
  oldStickersLine: string;
  dryWetInsideOutside: string;
  newWoodPosts: string;
  installerInfo: string;
  executedString: string;
  executedClass: string;
  executedIcon: string;
  album: IAlbum[];
  showExtraSupplier: boolean;
  extraHoogwerker: boolean;
  extraHoogwerkerDescription: string;
  parkingBan: boolean;
  extraInfoParkingBan: string;
  needExtraSupplier: boolean;
  extraInfoNeedExtraSupplier: string;
  showExtraMaterials: boolean;
  needExtraMaterials: boolean;
  extraInfoNeedExtraMaterials: string;
}
